import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { AddwithWhiteCircle, UpdatePencil } from '../AllSvg'
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { Modal } from 'react-bootstrap';
import { handleErrorToast } from '../custom';

const AddAuthorityDetail = ({ getAuthorityDetail }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        bank_name: '',
        designation: '',
        mobile_no: '',
        email: ''
    });

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateform = () => {
        const newErrors = {};
        const requiredFields = ["bank_name", "designation", "mobile_no", "email"];

        requiredFields.forEach((field) => {
            if (!formData[field]?.trim()) {
                newErrors[field] = `This field is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const res = await axios.post(`${BASE_URL}/project/authoritydetails/`, formData);

                if (res.status === 201 || res.status === 200) {
                    toast.success("Project name added successfully!");
                    setShow(false);
                    setFormData({
                        bank_name: '',
                        designation: '',
                        mobile_no: '',
                        email: ''
                    });
                    getAuthorityDetail();
                }
            } catch (err) {
                console.error("Error adding project name:", err);
                if (err.response?.data) {
                    toast.error(`Failed to add project name: ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to add project name");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>
            <button
                title="Add Division"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Authority
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add Authority Detail</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity" onSubmit={handleFormSubmit}>
                        <div className="parent-div">
                            <div className="bdy-div">
                                <div title="name" className="flex-column">
                                    <label
                                        htmlFor="bank_name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="bank_name"
                                        name="bank_name"
                                        placeholder="Enter Name"
                                        onChange={handleInputChange}
                                        value={formData.bank_name}
                                        className={`form-input  ${errors.bank_name ? "input-error" : ""}`}

                                    />
                                    {errors.bank_name && (
                                        <span className="error-message font-size-text">
                                            {errors.bank_name}
                                        </span>
                                    )}
                                </div>

                                <div title="Designation" className="flex-column">
                                    <label
                                        htmlFor="designation"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Designation<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="designation"
                                        name="designation"
                                        placeholder="Designation Name"
                                        onChange={handleInputChange}
                                        value={formData.designation}
                                        className={`form-input  ${errors.designation ? "input-error" : ""}`}

                                    />
                                    {errors.designation && (
                                        <span className="error-message font-size-text">
                                            {errors.designation}
                                        </span>
                                    )}
                                </div>

                                <div title="Mobile no." className="flex-column">
                                    <label
                                        htmlFor="mobile_no"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Mobile No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="mobile_no"
                                        name="mobile_no"
                                        placeholder="Mobile no"
                                        onChange={handleInputChange}
                                        value={formData.mobile_no}
                                        className={`form-input  ${errors.mobile_no ? "input-error" : ""}`}

                                    />
                                    {errors.mobile_no && (
                                        <span className="error-message font-size-text">
                                            {errors.mobile_no}
                                        </span>
                                    )}
                                </div>

                                <div title="Email" className="flex-column">
                                    <label
                                        htmlFor="email"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Email<span className="required">*</span>
                                    </label>
                                    <input
                                        type="mail"
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        onChange={handleInputChange}
                                        value={formData.email}
                                        className={`form-input  ${errors.email ? "input-error" : ""}`}

                                    />
                                    {errors.email && (
                                        <span className="error-message font-size-text">
                                            {errors.email}
                                        </span>
                                    )}
                                </div>

                            </div>

                            {/* Submit Button */}
                            <div className="button-models" style={{ width: '100%' }}>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-submit"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateAuthorityDetail = ({ i, getAuthorityDetail }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        bank_name: '',
        designation: '',
        mobile_no: '',
        email: ''
    });

    const handleShow = () => {
        setShow(true);
        setFormData(i);
    }
    const handleClose = () => setShow(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateform = () => {
        const newErrors = {};
        const requiredFields = ["bank_name", "designation", "mobile_no", "email"];

        requiredFields.forEach((field) => {
            const value = formData[field];
            if (!String(value || "").trim()) {
                newErrors[field] = `This field is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const res = await axios.put(`${BASE_URL}/project/authoritydetailsupdate/${i.id}/`,
                    {
                        bank_name: formData.bank_name,
                        designation: formData.designation,
                        mobile_no: formData.mobile_no,
                        email: formData.email,
                    }
                );

                if (res.status === 201 || res.status === 200) {
                    toast.success("Project name updated successfully!");
                    setShow(false);
                    setFormData({
                        bank_name: '',
                        designation: '',
                        mobile_no: '',
                        email: ''
                    });
                    getAuthorityDetail();
                }
            } catch (err) {
                console.error("Error updating project name:", err);
                if (err.response?.data) {
                    toast.error(`Failed to update project name: ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to update project name");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Update Project Name"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Update Authority Detail</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity" onSubmit={handleFormSubmit}>
                        <div className="parent-div">
                            <div className="bdy-div">
                                <div title="name" className="flex-column">
                                    <label
                                        htmlFor="bank_name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="bank_name"
                                        name="bank_name"
                                        placeholder="Enter Name"
                                        onChange={handleInputChange}
                                        value={formData.bank_name}
                                        className={`form-input  ${errors.bank_name ? "input-error" : ""}`}

                                    />
                                    {errors.bank_name && (
                                        <span className="error-message font-size-text">
                                            {errors.bank_name}
                                        </span>
                                    )}
                                </div>

                                <div title="Designation" className="flex-column">
                                    <label
                                        htmlFor="designation"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Designation<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="designation"
                                        name="designation"
                                        placeholder="Designation Name"
                                        onChange={handleInputChange}
                                        value={formData.designation}
                                        className={`form-input  ${errors.designation ? "input-error" : ""}`}

                                    />
                                    {errors.designation && (
                                        <span className="error-message font-size-text">
                                            {errors.designation}
                                        </span>
                                    )}
                                </div>

                                <div title="Mobile no." className="flex-column">
                                    <label
                                        htmlFor="mobile_no"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Mobile No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="mobile_no"
                                        name="mobile_no"
                                        placeholder="Mobile no"
                                        onChange={handleInputChange}
                                        value={formData.mobile_no}
                                        className={`form-input  ${errors.mobile_no ? "input-error" : ""}`}

                                    />
                                    {errors.mobile_no && (
                                        <span className="error-message font-size-text">
                                            {errors.mobile_no}
                                        </span>
                                    )}
                                </div>

                                <div title="Email" className="flex-column">
                                    <label
                                        htmlFor="email"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Email<span className="required">*</span>
                                    </label>
                                    <input
                                        type="mail"
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        onChange={handleInputChange}
                                        value={formData.email}
                                        className={`form-input  ${errors.email ? "input-error" : ""}`}

                                    />
                                    {errors.email && (
                                        <span className="error-message font-size-text">
                                            {errors.email}
                                        </span>
                                    )}
                                </div>

                            </div>

                            {/* Submit Button */}
                            <div className="button-models" style={{ width: '100%' }}>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-submit"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteAuthorityDetail = ({ i, getAuthorityDetail }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true)
    }

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project/authoritydetailsupdate/${i.id}/`
            );

            if (res.status === 200) {
                toast.success(`Data deleted successfully`);
                await getAuthorityDetail(); // refresh table
                setShow(false);
            }
        } catch (err) {
            toast.error("Failed to delete data");
            console.error(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Project Name"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Authority Detail: {i.bank_name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete{" "}
                        <strong>{i.name}</strong>?
                    </p>
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const AuthorityDietails = () => {

    const [buffer, setBuffering] = useState(true);

    const [authorityDetail, setAuthorityDetail] = useState([])

    const getAuthorityDetail = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/project/authoritydetails/`);
            setAuthorityDetail(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getAuthorityDetail()
    }, [])


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div >
                <div className="attendance-box">
                    <div className="datagrid-container">
                        <div className="custom-table-background" style={{ height: "66vh" }}>
                            <div className="">
                                <div className="">
                                    <div className="table-box ">
                                        <div className="flex-row table-heading" style={{ justifyContent: "end" }}>

                                            <AddAuthorityDetail getAuthorityDetail={getAuthorityDetail} />
                                        </div>
                                    </div>
                                    <div className='table-box scroll-container-table'
                                    >
                                        <table className="table-css width-100vw">
                                            <thead className="table-heading">
                                                <tr className="custom-table-head-tr">
                                                    <th className="table-heading ">S.no.</th>
                                                    <th className="table-heading text-left">Name</th>
                                                    <th className="table-heading text-left">Designation</th>
                                                    <th className="table-heading text-left">Mobile no.</th>
                                                    <th className="table-heading text-left">Email</th>
                                                    <th className="table-heading text-center">Action</th>
                                                </tr>
                                            </thead>
                                            {buffer ? (

                                                <div className="spinner-bgdatil"></div>

                                            ) :
                                                <tbody>
                                                    {
                                                        authorityDetail.map((i, index) => (
                                                            <tr key={index} className="custom-table-head-td">
                                                                <td>{index + 1}.</td>
                                                                <td>{i.bank_name}</td>
                                                                <td>{i.designation}</td>
                                                                <td>{i.mobile_no}</td>
                                                                <td>{i.email}</td>
                                                                <td>
                                                                    <div className='flex-row justify-center'>

                                                                        <UpdateAuthorityDetail i={i} getAuthorityDetail={getAuthorityDetail} />
                                                                        <DeleteAuthorityDetail i={i} getAuthorityDetail={getAuthorityDetail} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>

                                            }
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};



export default AuthorityDietails